import { cn } from '~/shared/lib/cn'

export function SkeletonBlock({ className }: { className?: string }) {
  return <div className={cn('bg-action-hovered animate-pulse rounded-sm', className)} />
}
